module.exports = __webpack_public_path__ + "img/home-grid-info-e-fireman.ca0d4c75.png";